import * as React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { UIHeading4 } from '@cian/ui-kit';
import { DurationGrid, DurationHorizontal } from './components';
import { useDurations } from './hooks/useDurations';
import { selectIsMobileLayout } from '../../../../../../selectors/layout';
import * as styles from './TermsDurations.css';

export const TermsDurationsContainer = () => {
  const isMobile = useSelector(selectIsMobileLayout);
  const { onShow } = useDurations();

  useEffect(() => {
    onShow();
  }, [onShow]);

  return (
    <div className={styles['wrapper']}>
      <UIHeading4>Срок продвижения</UIHeading4>

      {isMobile ? <DurationGrid /> : <DurationHorizontal />}
    </div>
  );
};
